import { render, staticRenderFns } from "./Ranktile.vue?vue&type=template&id=6db6adc0&scoped=true"
import script from "./Ranktile.vue?vue&type=script&lang=js"
export * from "./Ranktile.vue?vue&type=script&lang=js"
import style0 from "./Ranktile.vue?vue&type=style&index=0&id=6db6adc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6adc0",
  null
  
)

export default component.exports